import React, { useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

// Where a challenge notification goes (Jack, 2026-10-25): tapping it accepts
// the challenge and opens the game, instead of the lobby. `/challenge/:id`
// is a game or race challenge; `/race-invite/:id` a 3-player race invite,
// which opens the race once everyone is in (until then the Raider Races
// page opens on who it's waiting for, /race?wait3=1).
export default function ChallengeOpen({ race3 = false }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const once = useRef(null);

  useEffect(() => {
    if (once.current === id) return;
    once.current = id;
    (async () => {
      try {
        if (race3) {
          const { data } = await api.post(`/race3/invites/${id}/accept`);
          if (data.status === "started" && data.match_id) navigate(`/match/${data.match_id}?layout=race`, { replace: true });
          else navigate("/race?wait3=1", { replace: true });
          return;
        }
        const { data } = await api.post(`/challenges/${id}/accept`);
        navigate(`/match/${data.match_id}?layout=${data.match?.layout || "boardgame3"}`, { replace: true });
      } catch (e) {
        toast.error(formatApiError(e?.response?.data?.detail) || "That challenge has gone.");
        navigate(race3 ? "/race" : "/lobby", { replace: true });
      }
    })();
  }, [id, race3, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground" data-testid="challenge-open">
      Opening the game…
    </div>
  );
}
